import React, { useState, useRef } from "react";
import {
  Breadcrumb,
  Typography,
  Button,
  Space,
  Row,
  Col,
  Modal,
  Divider,
  Form,
} from "antd";
import { ActionType } from "@ant-design/pro-components";
import { PlusOutlined } from "@ant-design/icons";

import lang from "src/lang";

import has_permission from "src/common/utils/permission";
import AppointmentTable from "./tables/AppointmentTable";
import AppointmentStatistics from "./AppointmentStatistics";
import AddAppointment from "./add-appointment/AddAppointment";

const { Title } = Typography;

const Appointment: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  const actionRef = useRef<ActionType>();
  const [form] = Form.useForm();

  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
      }}
    >
      {/* Breadcrumb */}
      <Breadcrumb style={{ marginBottom: "16px" }} separator=">">
        <Breadcrumb.Item>{lang.get("breadcrumbs", ["Home"])}</Breadcrumb.Item>
        <Breadcrumb.Item>
          {lang.get("breadcrumbs", ["Appointment"])}
        </Breadcrumb.Item>
      </Breadcrumb>

      {/* Page Title */}
      <Title level={2} style={{ marginBottom: "16px" }}>
        {lang.get("appointments", ["Appointment"])}
      </Title>

      <Row
        gutter={[16, 16]}
        style={{ marginBottom: "16px" }}
        align="middle"
        justify="space-between"
      >
        {/* Left Section: Buttons */}
        <Col xs={24} sm={24} md={12} lg={12}>
          <Space size="middle" wrap>
            {has_permission("jobs", "job", "add") && (
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setShowModal(true)}
              >
                {lang.get("appointments", ["Add New Appointment"])}
              </Button>
            )}
          </Space>
        </Col>

        <Modal
          maskClosable={false}
          open={showModal}
          onCancel={() => {
            setShowModal(false);
            form.resetFields();
          }}
          footer={null}
          width={800}
          destroyOnClose
        >
          <AddAppointment
            form={form}
            onCancel={() => setShowModal(false)}
            actionRef={actionRef}
          />
        </Modal>
      </Row>

      <div style={{ marginTop: "16px" }}>
        <AppointmentStatistics />
      </div>
      <Divider />
      <div style={{ marginTop: "16px" }}>
        <AppointmentTable actionRef={actionRef} />
      </div>
    </div>
  );
};

export default Appointment;
